document.addEventListener("click", (event) => {
	const quickAddButton = event.target.closest(
		".quick-add__submit"
	);
	if (!quickAddButton) return;

	const modalOpener =
		quickAddButton.closest("modal-opener");
	if (!modalOpener) return;

	let modalId = modalOpener.getAttribute("data-modal");
	if (!modalId) return;
	modalId = modalId.replace("#", ""); // Remove the # from the ID

	const quickAddModal = document.getElementById(modalId);
	if (!quickAddModal) return;

	const modalContent = quickAddModal.querySelector(
		".quick-add-modal__content-info"
	);
	if (!modalContent) return;

	// Use MutationObserver to watch when content is added
	const observer = new MutationObserver(() => {
		const productMediaWrapper =
			modalContent.querySelector(
				".grid__item.product__media-wrapper"
			);
		const variantSelects = modalContent.querySelector(
			"variant-selects"
		);

		if (productMediaWrapper && variantSelects) {
			variantSelects.parentNode.insertBefore(
				productMediaWrapper,
				variantSelects
			);
			observer.disconnect(); // Stop observing after moving the element
		}
	});

	observer.observe(modalContent, {
		childList: true,
		subtree: true,
	});
});
